import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PropertyCard from "./PropertyCard";
import { ArrowUpRight } from "lucide-react";

const FILTER_CHIPS = [
  { label: "Under ₹15K", to: "/stays?max_price=15000" },
  { label: "₹15K – ₹30K", to: "/stays?min_price=15000&max_price=30000" },
  { label: "Premium ₹30K+", to: "/stays?min_price=30000" },
  { label: "Up to 12 guests", to: "/stays?guests=12" },
  { label: "20+ guests", to: "/stays?guests=20" },
  { label: "Pool", to: "/stays" },
  { label: "Lawn", to: "/stays" },
  { label: "Wedding", to: "/stays?occasion=Weddings" },
];

export default function MarketplacePreview() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/properties", { params: { managed: false, limit: 12 } })
      .then((r) => setItems(r.data.slice(0, 12)))
      .catch(() => {});
  }, []);

  return (
    <section className="bg-white border-y border-[#0E2E24]/8 py-20 md:py-24" data-testid="marketplace-preview-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-8">
          <div className="max-w-2xl">
            <div className="kicker mb-3">Marketplace</div>
            <h2 className="font-sora text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0E2E24] leading-tight">
              Explore more curated farmhouses.
            </h2>
          </div>
          <Link to="/stays" className="font-sora text-sm font-medium text-[#1F5A43] hover:text-[#0E2E24] flex items-center gap-1.5" data-testid="marketplace-see-all">
            Browse all 30 stays <ArrowUpRight size={15} />
          </Link>
        </div>

        {/* Filter chip bar */}
        <div className="mb-8 flex flex-wrap gap-2 no-scrollbar overflow-x-auto" data-testid="marketplace-filter-chips">
          {FILTER_CHIPS.map((c) => (
            <Link
              key={c.label}
              to={c.to}
              className="shrink-0 inline-flex items-center px-4 py-2 rounded-full bg-[#FAFAF8] border border-[#0E2E24]/10 text-sm font-sora font-medium text-[#0E2E24] hover:bg-[#E8F2EC] hover:border-[#1F5A43]/40 transition-colors"
              data-testid={`market-chip-${c.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
            >
              {c.label}
            </Link>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {items.map((p) => <PropertyCard key={p.id} p={p} />)}
        </div>
      </div>
    </section>
  );
}
